export default "__VITE_ASSET__DCRa0wT3__"